import { Logger } from './logger';
import { getWebSocketForPark } from './webSocketManager';
import { CURRENT_STATE, HISTORY } from './webSocketMiddleware.constants';

const WEBSOCKET_STATE_OPEN = 1;

export const webSocketSendMessage = (selectedPark, message) => {
    const webSocket = getWebSocketForPark(selectedPark);

    if (!webSocket) {
        Logger.debug(`WebSocket (${selectedPark}) not found!`);
        return false;
    }

    if (webSocket.readyState !== WEBSOCKET_STATE_OPEN) {
        Logger.debug(`WebSocket (${selectedPark}) not ready!`);
        return false;
    }

    Logger.debug(`WebSocket (${selectedPark}) send message:`, message);

    webSocket.send(message);

    return true;
};

export const webSocketSendGetCurrent = (selectedPark) => {
    const message = JSON.stringify({
        command: CURRENT_STATE,
        entityType: '*',
        entityKey: '*',
    });

    return webSocketSendMessage(selectedPark, message);
};

export const webSocketSendGetCurrentForTypes = (selectedPark, webSocketTypes = []) => {
    Logger.debug(`WebSocket (${selectedPark}) send message for types:`, webSocketTypes);

    // eslint-disable-next-line consistent-return,  no-restricted-syntax
    for (const type of webSocketTypes) {
        const message = JSON.stringify({
            command: CURRENT_STATE,
            entityType: type,
            entityKey: '*',
        });

        const result = webSocketSendMessage(selectedPark, message);
        if (!result) {
            throw new Error(`Failed to send message for type: ${type}`);
        }
    }

    return true;
};

export const webSocketSendGetHistory = (selectedPark, action) => {
    const { entityType, entityKey, count, precision, fields } = action;

    const message = JSON.stringify({
        command: HISTORY,
        entityType,
        entityKey,
        count,
        precision,
        fields,
    });

    webSocketSendMessage(selectedPark, message);
};

export const webSocketSendGetHistoricalProductionForecast = (selectedPark, action) => {
    const { entityKey, precision, count } = action;

    const message = JSON.stringify({
        command: 'HISTORY',
        entityType: 'HISTORICAL_PRODUCTION_FORECAST',
        entityKey,
        precision,
        count,
        fields: ['active_power'],
    });

    webSocketSendMessage(selectedPark, message);
};

export const webSocketSendGetWeatherHistory = (selectedPark, action) => {
    const { entityKey, precision, count } = action;

    const message = JSON.stringify({
        command: 'HISTORY',
        entityType: 'WEATHER',
        entityKey,
        precision,
        count,
        fields: [
            'wind_speed',
            'wave_height',
            'ambient_temperature',
            'tide_height',
            'wind_direction',
            'water_temperature',
        ],
    });

    webSocketSendMessage(selectedPark, message);
};

export const webSocketSendGetWeatherForecast = (selectedPark, action) => {
    const { count } = action;
    const message = JSON.stringify({
        command: CURRENT_STATE,
        entityType: 'WEATHER_FORECAST',
        entityKey: 'WEATHER_FORECAST',
        count,
    });

    return webSocketSendMessage(selectedPark, message);
};
